const UPDATE_PLOT_BANDS = 'UPDATE_PLOT_BANDS';
const UPDATE_PLOT_BAND_PRESETS = 'UPDATE_PLOT_BAND_PRESETS';
const UPDATE_SHOW_UK_RECESSIONS = 'UPDATE_SHOW_UK_RECESSIONS';
const UPDATE_SHOW_US_RECESSIONS = 'UPDATE_SHOW_US_RECESSIONS';

const updatePlotBands = (payload) => ({ type: UPDATE_PLOT_BANDS, payload });

const updatePlotBandPresets = (payload) => ({ type: UPDATE_PLOT_BAND_PRESETS, payload });

const updateShowUkRecessions = (payload) => ({ type: UPDATE_SHOW_UK_RECESSIONS, payload });

const updateShowUsRecessions = (payload) => ({ type: UPDATE_SHOW_US_RECESSIONS, payload });

export {
  UPDATE_PLOT_BANDS,
  UPDATE_PLOT_BAND_PRESETS,
  UPDATE_SHOW_UK_RECESSIONS,
  UPDATE_SHOW_US_RECESSIONS,
  updatePlotBands,
  updatePlotBandPresets,
  updateShowUkRecessions,
  updateShowUsRecessions,
};
